/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQueries } from "@tanstack/react-query";
import input from "../../../assets/styles/components/input.module.css";
import { getCidade, getEstado } from "../../../services/address";
import ModalGeneric from "../../../components/ModalGeneric/ModalGeneric";
import styles from "./Filter.module.css";

interface IFilter {
  estado?: string;
  municipio?: string;
}

interface prop {
  dataFilter: IFilter;
  handleDataFilter: (value: string, key: keyof IFilter) => void;
  onClose: () => void;
}

const Filter = ({ handleDataFilter, onClose, dataFilter }: prop) => {
  const handleChange = (e: string, key: keyof IFilter) => {
    handleDataFilter(e, key);
  };

  const [estadoQuery, cidadeQuery] = useQueries({
    queries: [
      {
        queryKey: ["getEstado"],
        queryFn: () => getEstado(),
        refetchOnWindowFocus: false,
      },
      {
        queryKey: ["getCidade", dataFilter.estado],
        queryFn: () => getCidade(dataFilter.estado || ""),
        refetchOnWindowFocus: false,
        enabled: !!dataFilter.estado,
      },
    ],
  });

  return (
    <ModalGeneric
      onClick={() => onClose?.()}
      title="Filtrar Fornecedor"
      modalGenericCustom={styles.modalCustom}
    >
      <div className={styles.filter}>
        <div className={styles.row}>
          <label>
            Estado
            <select
              className={input.input}
              value={dataFilter.estado}
              onChange={(e) => handleChange(e.target.value as any, "estado")}
            >
              <option value="">Selecione o Estado</option>
              {estadoQuery &&
                estadoQuery.data?.length > 0 &&
                estadoQuery.data?.map(
                  (state: { id_estado: string; estado: string }) => (
                    <option key={state.id_estado} value={state.id_estado}>
                      {state.estado}
                    </option>
                  ),
                )}
            </select>
          </label>
          <label>
            Município
            <select
              className={input.input}
              value={dataFilter.municipio}
              onChange={(e) => handleChange(e.target.value as any, "municipio")}
            >
              <option value="">Selecione o Município</option>
              {cidadeQuery &&
                cidadeQuery?.data?.length > 0 &&
                cidadeQuery.data.map(
                  (city: { id_municipio: string; municipio: string }) => (
                    <option key={city.id_municipio} value={city.id_municipio}>
                      {city.municipio}
                    </option>
                  ),
                )}
            </select>
          </label>
        </div>
      </div>
    </ModalGeneric>
  );
};

export default Filter;
